import "./content-page.css";

/**
 * The shared layout behind /about, /privacy, /terms, /refunds, /help and
 * /pricing.
 *
 * These are the pages a Razorpay reviewer reads, so they are built to be read:
 * one column at a real measure, a heading scale that separates sections
 * without shouting, and the date the document last changed at the top where
 * someone checking currency will look for it.
 */
export default function ContentPage({ title, updated, lead, children }) {
  return (
    <div className="content-page">
      <div className="container content-page__inner">
        <header className="content-page__head">
          <h1 className="t-display-2">{title}</h1>
          {updated && (
            <p className="content-page__updated">Last updated {updated}</p>
          )}
          {lead && <p className="t-lead content-page__lead">{lead}</p>}
        </header>
        <div className="content-page__body">{children}</div>
      </div>
    </div>
  );
}

export function Section({ heading, body = [], items = [] }) {
  return (
    <section className="content-page__section">
      <h2 className="content-page__heading">{heading}</h2>
      {body.map((paragraph) => (
        <p className="t-body content-page__paragraph" key={paragraph}>
          {paragraph}
        </p>
      ))}
      {items.length > 0 && (
        <ul className="content-page__list">
          {items.map((item) => (
            <li className="content-page__item" key={item}>
              {item}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
